import { subscribe, useSnapshot } from "valtio"
import { AgInput, AgSelect, TableEdit, TableSelect } from "../components/AgComponents"
import { useEffect, useState } from "react"
import { PortsMarkup, markupsStore, rtpStore } from "./pricing-store"
import { ServerLists } from "../StaticData"

function ActionButtons(props) {
    useSnapshot(markupsStore)
    let line = props.line
    let len = props.length
    return (
        <div className="field has-addons">
            {
                (line !== len - 1) ?
                    <p className="control">
                        <button className="button is-danger is-small is-inverted"
                            onClick={() => {
                                let list = [...markupsStore.current.portsMarkup]
                                list.splice(line, 1)
                                markupsStore.current.portsMarkup = list
                            }}>
                            <span className="icon is-small">
                                <i className="fas fa-trash"></i>
                            </span>
                        </button>
                    </p> : <></>
            }
            {
                (line === len - 1) ?
                    <p className="control">
                        <button className="button is-success is-small is-inverted"
                            onClick={() => {
                                markupsStore.current.portsMarkup.push(new PortsMarkup())
                            }}>
                            <span className="icon is-small">
                                <i className="fas fa-plus"></i>
                            </span>
                        </button>
                    </p> : <></>
            }
        </div>
    )
}
export default function AirpricingPortsmarkup(props) {
    useSnapshot(markupsStore)
    useSnapshot(rtpStore)

    let rec = rtpStore.selectedMarkupCharge

    return (
        <>
            <table className="table is-narrow is-bordered is-small"
                style={{ fontSize: '0.8rem', textAlign: 'center' }}>
                <thead>
                    <tr>
                        <th>#</th>
                        {rec.hasaor && <th>AOR</th>}
                        {rec.hasaod && <th>AOD</th>}
                        {rec.hasiata && <th>IATA</th>}
                        {rec.hasaoa && <th>AOA</th>}
                        {rec.hasfpod && <th>FPOD</th>}
                        <th>Markup</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        markupsStore.current.portsMarkup?.map((e, i) => (
                            <tr key={'' + i + e.aor+e.aod+e.iata+e.aoa+e.fpod}>
                                <td>
                                    {i + 1}
                                </td>
                                {rec.hasaor &&
                                    <td><TableSelect record={e} name='aor'
                                        dataList={rec.aorlist} /></td>}
                                {rec.hasaod &&
                                    <td><TableSelect record={e} name='aod'
                                        dataList={rec.aodlist} /></td>}
                                {rec.hasiata &&
                                    <td><TableSelect record={e} name='iata'
                                        dataList={rec.iatalist} /></td>}
                                {rec.hasaoa &&
                                    <td><TableSelect record={e} name='aoa'
                                        dataList={rec.aoalist} /></td>}
                                {rec.hasfpod &&
                                    <td><TableSelect record={e} name='fpod'
                                        dataList={rec.fpodlist} /></td>}
                                <td>
                                    <TableEdit type='number'
                                        style={{ width: '4rem', textAlign: 'right' }}
                                        record={e} name='markup' />
                                </td>
                                <td>
                                    <ActionButtons line={i} length={markupsStore.current.portsMarkup?.length} />
                                </td>
                            </tr>
                        )
                        )
                    }
                </tbody>
            </table>

        </>
    )
}